import { render } from "./problemEnvironment.vue?vue&type=template&id=5f620024"
import script from "./problemEnvironment.vue?vue&type=script&lang=js"
export * from "./problemEnvironment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__